import { SortOrder } from '../sorting/sort-order.enum';

export class FindAllQuerySorting<Entity extends object> {
	by: keyof Entity;
	order: SortOrder;
}

export class FindAllQueryFilter<Entity extends object> {
	by: keyof Entity;
	values: unknown[];
}

export class FindAllQueryDto<Entity extends object> {
	page?: number;
	pageSize?: number;
	sort?: FindAllQuerySorting<Entity>[];
	filter?: FindAllQueryFilter<Entity>[];
}
